/*
 * @Author: long
 * @Date: 2022-03-14 09:16:19
 * @LastEditTime: 2022-11-15 16:44:29
 * @LastEditors: long
 * @Description:
 * @FilePath: /website/Users/long/Documents/workspace/components/config/menu.js
 *
 */
const systemMenuList = JSON.parse(localStorage.getItem("systemList"));

/**
 *
 * @param {*} systemCode
 * @param {*} filter  是否过滤掉编辑显示列
 * @returns
 */
export function getMenuList(systemCode, filter) {
  let menuGroup = [];
  const mod = getSystemModule(systemMenuList, systemCode);
  if (mod && Array.isArray(mod.children)) {
    mod.children.forEach((item) => {
      formatMenu(menuGroup, item, filter);
    });
  }
  return menuGroup;
}

function formatMenu(list, item, filter) {
  const current = {
    name: getMenuInfo(item, "menuDesc"),
    path: getMenuInfo(item, "menuUrl"),
    meta: {
      menuId: item.menuId,
      title: getMenuInfo(item, "menuName"),
      icon: item.icon,
      keepAlive: item.routeCache === 2,
    },
  };

  if (item.children && item.children.length) {
    current.children = [];
    item.children.forEach((row) => {
      formatMenu(current.children, row, filter);
    });
  }
  if (filter) {
    if (!["编辑显示列", "编辑导出列"].includes(getMenuInfo(item, "menuName"))) {
      list.push(current);
    }
  } else {
    list.push(current);
  }
}

function getMenuInfo(item, key) {
  return (item.configMenuInfo && item.configMenuInfo[key]) || item[key];
}

function getSystemModule(list, systemCode) {
  let result = {};
  if (!list) return result;
  for (let item of list) {
    if (item.systemCode === systemCode) {
      result = item;
      break;
    }
  }
  return result;
}
